<template>
  <div class="systemSetting_main" :class="{'cn':version == '1','ja':version == '2'}">
    <!-- <div class="bg"></div> -->
    <div class="cont_box scrollbar_style" >
      
      
      <div class="cont_left">
        <div class="text p1"><span class="i">*</span>{{ $t('App.systemSetting.text1') }}</div>
        <div class="usertype" style="display: flex">
          <div class="avatar_box">
            <div v-if="!avatar" class="avatar avatar0"></div>
            <div  v-if="avatar" >
              <img class="avatar" :src="avatar_">
            </div>
          </div>
          <div class="select1">
            <div class="select_lm" :class="profileSelectShow ? 'select' : ''">
              <div class="val_box" @click="profileSelectFun">
                {{$t('App.systemSetting.text24')}}
                <div class="icon_x"></div>
              </div>
              <div class="select_xl_lm_bg" v-if="profileSelectShow"
                @click="profileSelectFun"></div>
              <div class="select_xl_lm" v-if="profileSelectShow">
                <div class="icon"></div>
                <div class="ul scrollbar_style">
                  <div class="text">
                    <div class="text1">{{$t('App.systemSetting.text22')}}</div>
                    <div class="skin_setting" >
                      <div class="li" v-for="(item,index) in avatarOptions" :key="index"  @click="avatarChange(item,index)" >
                        <!-- <div> -->
                          <img  style="width: 100%;" slot="prefix" :src="item.src"/>
                        <!-- </div> -->
                      </div>
                    </div> 
                    <div class="text3">{{$t('App.systemSetting.text23')}}</div>
                    <div class="form_item">
                      <el-upload class="avatar-uploader"
                      name="avatarFile"
                      :data="imgUploadData" :action="actionImgUrl" 
                      :show-file-list="false" :on-success="handleAvatarSuccess" 
                      :before-upload="beforeAvatarUpload">
                        <img class="btn" v-if="avatar" :src="avatar_">
                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                        <span class="btn btn0" v-if="!avatar"></span>
                      </el-upload>
                      <!-- <div class="icon icon7"></div>
                      <div class="icon btn"></div> -->
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form_box"  ref="formUser" :model="formUser" >
          <el-input class="input1" v-model="formUser.username3" :disabled="true" :placeholder="$t('App.systemSetting.text2')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_2.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_1.png"/>
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_1.png"/>
          </el-input>
          <el-input class="input1 " show-password v-model="formUser.password2" :placeholder="$t('App.systemSetting.text3')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_3.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_3.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_3.png" />
          </el-input>

          <el-input class="input1 " v-model="formUser.email" :placeholder="$t('App.email')">
            <img class="icon0" v-if="themeType == 0" style="width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/login/email.png" />
            <img class="icon0" v-if="themeType == 1" style="width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/orange/email.png" />
            <img class="icon0" v-if="themeType == 2" style="width: 1.85rem; opacity: 0.85;" slot="prefix" src="../img/grey/email.png" />
          </el-input>

          <el-input class="input1" v-model="formUser.username2" :placeholder="$t('App.systemSetting.text4')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_2.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_1.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_1.png" />
          </el-input>
          <el-input class="input1" show-password v-model="formUser.password" :placeholder="$t('App.systemSetting.text5')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_3.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_3.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_3.png" />
          </el-input>
          <el-input class="input1 margin_b" show-password v-model="formUser.confirmPassword" :placeholder="$t('App.systemSetting.text6')">
            <img class="icon" v-if="themeType == 0" slot="prefix" src="../img/login/login_4.png" />
            <img class="icon" v-if="themeType == 1" slot="prefix" src="../img/orange/login_4.png" />
            <img class="icon" v-if="themeType == 2" slot="prefix" src="../img/grey/login_4.png" />
          </el-input>

          <!-- <el-select class="input1" v-model="formUser.ldentity" :placeholder="$t('App.systemSetting.text7')" popper-class="select_popper">
            <span class="span" slot="prefix">ID</span>
            <el-option v-for="item in ldentityOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select> -->

          <div class="addUser_btn" @click="pageTypeFun('subAccountSetting')" v-if="role == 0||role == 3">
            <div class="icon"></div>
          </div>
          <div class="btn_box">
            <div class="btn1" @click="logOut()">{{$t('App.systemSetting.text8')}}</div>
            <div class="btn2" @click="editUserUpdate()">{{$t('App.systemSetting.text9')}}</div>
          </div>
        </div>
      </div>
      <div class="cont_right" ref="formUserUpdateTimezoneContact" :model="formUserUpdateTimezoneContact">
        <div class="text p1"><span class="i">*</span>{{ $t('App.systemSetting.text10') }}</div>
        <div class="input1">
          <div class="select_lm" :class="{'select': projectSelectShow,'noSelect':role == 2}">
            <div class="val_box"  @click="timezoneSelectFun">
              <!-- <img class="icon" style="width: 2.43rem;height: 2.24rem;" slot="prefix" src="../img/icon/timeZone.png" /> -->
              <div class="icon"></div>
              <div class="val" :title="timezoneName">{{ timezoneName }}</div>
              <div class="icon_x"></div>
            </div>
            <div class="select_xl_lm_bg" v-if="projectSelectShow" @click="timezoneSelectFun" ></div>
            <div class="select_xl_lm" v-if="projectSelectShow">
              <div class="icon"></div>
              <div class="ul scrollbar_style">
                <div class="li" v-for="(item, index) in timezoneList" :key="index" @click="provinceItemClick(item)">
                  <span class="text">{{ item.name }}</span>
                  <!-- <div class="selectDrop" :class="item.select==1?'select':''">
                    <div class="drop"></div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text p1"><span class="i">*</span>{{ $t('App.systemSetting.text13') }}</div>
        <div class="skin_setting">
          <div class="li li1" @click="skinFun(2)"></div>
          <div class="li li2" @click="skinFun(0)"></div>
          <div class="li li3" @click="skinFun(1)"></div>
          <!-- <div class="li add"></div> -->
        </div>
        <div class="text p1"><span class="i">*</span>{{ $t('App.systemSetting.text14') }}</div>
        <div class="contacts_settings" >
          <div class="box box1">
            <div class="box_l">
              <div class="icon"></div>
              <div class="text">{{$t('App.systemSetting.text15')}}</div>
            </div>
            <div class="box_r">
              <el-input v-model="formUserUpdateTimezoneContact.faultContact" class="input2" :disabled="role == 2" :placeholder="$t('App.systemSetting.text16')"></el-input>
              <el-input v-model="formUserUpdateTimezoneContact.faultEmail" class="input3" :disabled="role == 2" :placeholder="$t('App.systemSetting.text17')"></el-input>
            </div>
          </div>
          <div class="box box2">
            <div class="box_l">
              <div class="icon"></div>
              <div class="text">{{$t('App.systemSetting.text18')}}</div>
            </div>
            <div class="box_r">
              <el-input v-model="formUserUpdateTimezoneContact.tempContact" class="input2" :disabled="role == 2" :placeholder="$t('App.systemSetting.text16')"></el-input>
              <el-input v-model="formUserUpdateTimezoneContact.tempEmail" class="input3" :disabled="role == 2" :placeholder="$t('App.systemSetting.text17')"></el-input>
            </div>
          </div>
          <div class="box box3">
            <div class="box_l">
              <div class="icon"></div>
              <div class="text">{{$t('App.systemSetting.text19')}}</div>
            </div>
            <div class="box_r">
              <el-input v-model="formUserUpdateTimezoneContact.warrantyContact" class="input2" :disabled="role == 2" :placeholder="$t('App.systemSetting.text16')"></el-input>
              <el-input v-model="formUserUpdateTimezoneContact.warrantyEmail" class="input3" :disabled="role == 2" :placeholder="$t('App.systemSetting.text17')"></el-input>
            </div>
          </div>
        </div>
        <!-- 重建引导模式 -->
        <template v-if="role != 2">
          <div class="text p1"><span class="i">*</span>{{ $t('App.systemSetting.text30') }}</div>
          <div class="project_settings">
            <div class="button" @click="setUserSettingInfo()" v-loading="loading.setUserSettingInfo">{{ $t('App.systemSetting.text31') }}</div>
            <div class="button button1" @click="showLogout()" v-loading="loading.resetProject">{{ $t('App.systemSetting.text32') }}</div>
          </div>
          <div class="text p2"><span class="i">*</span>{{ $t('App.systemSetting.text33') }}</div>
        </template>
        <div class="btn_box">
          <div class="btn1 text" @click="logOut()">{{$t('App.exit')}}</div>
          <div class="btn2 text" :class="{'noSelect':role == 2}" @click="editUserUpdateTimezoneContact()">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>
    <!-- 重置账户 -->
    <div class="dialog_box" v-if="isShowLogout">
      <div class="bg"></div>
      <div class="form_box" >
        <div class="span">
          {{$t('App.login.text4')}}
        </div>
          <!-- <el-input class="input1"  :placeholder="$t('App.subAccountSetting.text2')">
            <img class="icon" slot="prefix" src="../img/login/login_2.png" />
          </el-input> -->
          <el-input class="input1" show-password prop="password" v-model="formUser.password">
            <img class="icon" slot="prefix" src="../img/login/login_3.png" />
          </el-input>
        
        <div class="btn_box">
          <div class="btn1" @click="isShowLogout = false">{{$t('App.exit')}}</div>
          <div class="btn2" @click="resetProjectInfo()">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div> 
    
    <!-- 选择页面 -->
    <el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
      <el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_">
        <el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
      </el-radio-group>
      <span  slot="footer" class="footer">
        <el-button @click="projectSelection()">{{$t('App.ok')}}</el-button>
      </span>
    </el-dialog>
    
    <!-- 获取用户设置状态信息 -->
    <div class="project_completed" v-if="isShowprojectCompleted">
      <div class="bg"></div>
      <div class="form_box" >
        <div class="span">
          {{$t('App.text14')}}
        </div>
        <div class="btn_box">
          <!-- <div class="btn1" @click="isShowLogout = false">{{$t('App.no')}}</div> -->
          <div class="btn2" @click="closeProjectCompleted('calendar')">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import allUrl from "../api/allUrl.js";
import base from "../api/base.js";

export default {
  name: "systemSetting",
  data() {
    return {
      themeType_: '',

      avatarPhoto:'',
      avatarOptions:[],

      protocolStr:'',
      domainName:'',
      isShowLogout: false,
      isShowprojectCompleted: false,
      formUser: {
        //   username: '',
        // id: "",
        username2: "",
        password: "",
        confirmPassword: "",
        username3: "",
        password2: "",
        email:"",
        projectIds:'',
        // type: '',
      },
      ldentityOptions: [],
      timeZoneOptions: [],
      projectSelectShow: false,
      profileSelectShow: false,
      timezoneId: "",
      timezoneName: "",
      timezoneList: [],
      avatar:"",
      formUserUpdateTimezoneContact: {
        // id: "",
        // timezoneId: "",
        
        faultContact: "",
        faultEmail: "",
        tempContact: "",
        tempEmail: "",
        warrantyContact: "",
        warrantyEmail: "",
      },
      
      selectVisible: false,
      getUserSettingInfoDateValue_:'systemSetting',
      getUserSettingInfoDate :{
        sysStatus:'',
        projectStatus:'',
        gatewayStatus:'',
        deviceStatus:'',
        groupStatus:'',
        sceneStatus:'',
        scheduleStatus:'',
      },

      loading: {
        userAdd: false,
        useredit: false,
        userUpdateTimezoneContact: false,
        setUserSettingInfo: false,
        resetProject: false,
      },
      userDetailsData:[],
      // userid:'',
      actionImgUrl: '',
      imgUploadData: {
        username: '',
        clientType: '0',
        version: '0',
        token: '',
        id:'',
      },

    };
  },
  computed: {
    ...mapGetters({
      token: "token",
      client_key: "client_key",
      username: "username",
      version: "version",
      role: "role",

      projectUpdate:'projectUpdate',
      

      id: 'id',
      remRatio: "remRatio",
      updateRemRatio: "updateRemRatio",

      countryId: "countryId",
      provinceId: "provinceId",
      cityId: "cityId",
      hotelId: "hotelId",
      headerIdStr: "headerIdStr",
      userDetailsGetUpdate: "userDetailsGetUpdate",

      projectId:'projectId',
      themeType: 'themeType',
    }),
    avatar_ () {
      let str = ''
      if(this.avatar.startsWith('http')){
        str = this.avatar;
      }else{
        str = this.protocolStr+'//'+this.domainName+'/'+this.avatar;
      }
      return str
    }
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy() {
    
    this.$store.commit('themeTypeFun', {
        themeType: this.themeType_,
      })
  },
  mounted() {
    this.themeType_ = this.themeType
    this.getUserSettingInfo();
    this.protocolStr = document.location.protocol;
    this.domainName = window.location.href.split("/")[2];
    if(this.domainName == 'localhost:8080' || this.domainName == '127.0.0.1:8080'){
        this.domainName = 'lighting.lampmind.com'
    }
    console.log(this.id)    
    this.imgUploadData.username = this.username;
    this.imgUploadData.id = this.id;
    this.imgUploadData.token = this.token;
    this.imgUploadData.version = this.version;
    this.actionImgUrl = allUrl.user.user_updateAvatar;
    // this.userDetailsGet();
    this.ldentityOptions = [
      { id: "1", name: this.$t("App.systemSetting.ldentity1") },
      { id: "2", name: this.$t("App.systemSetting.ldentity2") },
      { id: "3", name: this.$t("App.systemSetting.ldentity3") },
      { id: "4", name: this.$t("App.systemSetting.ldentity4") },
    ];
    this.timeZoneOptions = [
      { id: "1", name: this.$t("App.systemSetting.text11") },
      { id: "2", name: this.$t("App.systemSetting.text12") },
    ];
    this.avatarOptions = [
      { id: "1", src:this.protocolStr+'//'+this.domainName+'/'+"upload/image/1728721806151.png" },
      { id: "2", src:this.protocolStr+'//'+this.domainName+'/'+"upload/image/1728721878738.png" },
      { id: "3", src:this.protocolStr+'//'+this.domainName+'/'+"upload/image/1728721904681.png" },
      { id: "4", src:this.protocolStr+'//'+this.domainName+'/'+"upload/image/1728721921348.png" },
    ];
    this.timezoneNavList();
    this.userDetailsGet();

  },
  methods: {
    skinFun(index){
      this.$store.commit('themeTypeFun', {
        themeType: index,
      })
    },
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';

      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      console.log(this.themeType,'95959999---')
      return obj
    },
    confirmSelection() {
      this.getUserSettingInfo(data => {
        if (data.isTrue) {
          this.selectVisible = true;
        }
      });
    },
    projectSelection(){
      // console.log(this.getUserSettingInfoDateValue,'-99999999-1111')
      
      // this.$store.commit("getUserSettingInfoSelectFun", {
      //   getUserSettingInfoDateValue: this.getUserSettingInfoDateValue_,
      // });
      console.log(this.getUserSettingInfoDateValue_)
      this.pageTypeFun(this.getUserSettingInfoDateValue_)
      this.selectVisible = false;
    },
    closeProjectCompleted() {
			this.isShowprojectCompleted = false;
			this.$emit('pageTypeFun','projectSettings')
		},
    //更换头像
    avatarChange(data){
      this.avatarPhoto = data.src
      console.log(this.avatarPhoto,'--1111')
      base.ajax_post(
          allUrl.user.user_updateAvatar,
          {
            username: this.username,
            id: this.id,
            version: this.version,
            token:this.token,
            fileType:1,
            path: this.avatarPhoto
            // avatarFile: this.avatarFile,
          },
          {},
          data =>{
            this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
            });
            this.userDetailsGet();
          },
        this)
    },
    //重置项目信息
    resetProjectInfo(){
      console.log(this.projectId,this.formUser.password,'--5-5-999')
      this.$confirm(
          this.$t('App.message.text43'), this.$t('App.message.text4'), {
              confirmButtonText: this.$t('App.message.text5'),
              cancelButtonText: this.$t('App.message.text6'),
              type: 'warning'
          }
      ).then(() => {
        this.loading.resetProject = true;
        base.ajax_post(
            allUrl.project.project_resetProject,
            {
              username: this.username,
              version: this.version,
              token:this.token,
              id:this.projectId,
              // ...this.formUser,
              password: this.formUser.password
            },
            {},
            data =>{
              this.$message({
                  showClose: true,
                  message: data.msg,
                  type: 'success'
              });
              this.isShowLogout = false;
              this.loading.resetProject = false;
              this.$store.commit('projectUpdateFun', {
                projectUpdate: this.projectUpdate+1,
              })
              // this.userListGet();
            },
          this,()=>{
            this.loading.resetProject = false;
          })
      }).catch(() => {
          this.$message({
              type: 'info',
              message: this.$t('App.message.text44')
          });    
      });
    },
    //重置用户设置信息
    setUserSettingInfo() {
      this.$confirm(
          this.$t('App.message.text43'), this.$t('App.message.text4'), {
              confirmButtonText: this.$t('App.message.text5'),
              cancelButtonText: this.$t('App.message.text6'),
              type: 'warning'
          }
      ).then(() => {
        this.loading.setUserSettingInfo = true;
        base.ajax_post(
            allUrl.user.user_setUserSettingInfo,
            {
              username: this.username,
              version: this.version,
              token:this.token,
            },
            {},
            data =>{
              this.$message({
                  showClose: true,
                  message: data.msg,
                  type: 'success'
              });
              this.loading.setUserSettingInfo = false;
              this.getUserSettingInfo()
              // this.userListGet();
            },
          this,()=>{
            this.loading.setUserSettingInfo = false;
          })
      }).catch(() => {
          this.$message({
              type: 'info',
              message: this.$t('App.message.text44')
          });
      });
    },
		//获取用户设置状态信息
		getUserSettingInfo(callback) {
			// this.selectVisible = true;
			base.ajax_post(
				allUrl.user.user_getUserSettingInfo,
				{
				username: this.username,
				version: this.version,
				token:this.token,
				},
				{},
				data => {
          this.getUserSettingInfoDate = data.data;
          data.isTrue = false;
          if(this.getUserSettingInfoDate.sysStatus == 0){
            this.getUserSettingInfoDateValue_ = 'systemSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.projectStatus == 0){
            this.getUserSettingInfoDateValue_ = 'projectSettings'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
            this.getUserSettingInfoDateValue_ = 'gatewayInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.deviceStatus == 0){
            this.getUserSettingInfoDateValue_ = 'controllerInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.groupStatus == 0){
            this.getUserSettingInfoDateValue_ = 'groupSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.sceneStatus == 0){
            this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
            this.getUserSettingInfoDateValue_ = 'schedule'
            data.isTrue = true
          }
          if(callback){
            callback(data)
          }
				},
				this
			)
		},
    handleAvatarSuccess (data, avatarFile) {
      console.log(avatarFile,'--66666666-')
      // console.log(avatarFile.response.data.image,'--88888888-')
      // this.avatar = avatarFile.raw.name;
      this.$message({
        showClose: true,
        message: data.msg,
        type: "success",
      });
      this.userDetailsGet();
    },
    beforeAvatarUpload (avatarFile) {
      const isJPG = avatarFile.type === 'image/jpeg';
      const isPNG = avatarFile.type === 'image/png';
      const isBMP = avatarFile.type === 'image/bmp';

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.error(this.$t('App.message.imgType'));
      }
      return isJPG || isPNG|| isBMP;
      
    },
    //编辑用户
    editUserUpdate() {
      // this.dialogShow = false
      if (this.loading.useredit) {
        return;
      }
      this.loading.useredit = true;
      base.ajax_post(
        allUrl.user.user_update,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          clientType: this.os,
          id: this.id,
          ...this.formUser,
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
          this.loading.useredit = false;
          this.userDetailsGet();
          console.log(1121, "-----555---");
        },
        this,
        () => {
          this.loading.useredit = false;
          // this.userDetailsGet();
          // this.dialogShow = false
        }
      );
      // this.dialogShow = false
      // this.userDetailsGet();
      console.log(1111, "-----555---");
    },
    //弹出退出登录弹窗
    showLogout() {
      this.isShowLogout = true;
    },
    closeLogout() {
      this.isShowLogout = false;
    },
    //退出登录
    logOut(){
      
      this.$emit('pageTypeFun', '')
    },
    //编辑时区、邮箱和设备故障联系人
    editUserUpdateTimezoneContact() {
      if(this.role == 2){
        return
      }
      // this.dialogShow = false
      if (this.loading.userUpdateTimezoneContact) {
        return;
      }
      
      base.ajax_post(
        allUrl.user.user_updateUserSkin,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          themeType: this.themeType,
          id: this.id,
        },
        {},
        data =>{
          this.$message({
              showClose: true,
              message: data.msg,
              type: 'success'
          });
          this.themeType_ = this.themeType
          // this.loading.setUserSettingInfo = false;
          // this.userListGet();
          console.log(this.themeType)
        },
      this,()=>{
        // this.loading.setUserSettingInfo = false;
      })

      base.ajax_post(
        allUrl.user.user_updateTimezoneContact,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          clientType: this.os,
          id: this.id,
          timezoneId: this.timezoneId,
          ...this.formUserUpdateTimezoneContact,
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
          this.loading.userUpdateTimezoneContact = false;
          this.userDetailsGet();
          this.$store.commit('userDetailsGetUpdateFun', {
            userDetailsGetUpdate: this.userDetailsGetUpdate+1,
          })
          
          if(this.getUserSettingInfoDate.sysStatus == 0){
            this.getUserSettingInfoDate.sysStatus = 1
            this.confirmSelection()
          }
          console.log(1121, "-----555---");
        },
        this,
        () => {
          this.loading.userUpdateTimezoneContact = false;
          // this.userDetailsGet();
          // this.dialogShow = false
        }
      );
      // this.dialogShow = false
      // this.userDetailsGet();
      console.log(1111, "-----555---");
    },
    // 用户消息详情
    userDetailsGet() {
      base.ajax_post(
        allUrl.user.user_userDetails,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          clientType: this.os,

          id: this.id,
        },
        {},
        (data) => {
          this.userDetailsData = data.data;
          this.formUser.username3 = data.data.username;
          this.formUser.projectIds = data.data.projectIds;
          
          this.avatar = data.data.avatar
          this.timezoneName = data.data.timezoneName;
          this.timezoneId = data.data.timezoneId;
          console.log(data.data,'--11-22222')
          this.formUserUpdateTimezoneContact.faultContact = data.data.faultContact;
          this.formUserUpdateTimezoneContact.faultEmail = data.data.faultEmail;
          this.formUserUpdateTimezoneContact.tempContact = data.data.tempContact;
          this.formUserUpdateTimezoneContact.tempEmail = data.data.tempEmail;
          this.formUserUpdateTimezoneContact.warrantyContact = data.data.warrantyContact;
          this.formUserUpdateTimezoneContact.warrantyEmail = data.data.warrantyEmail;
          
          let obj = {
            username: data.data.username,
            id: data.data.id,
            role: data.data.type,
            token: this.token,
            avatar: data.data.avatar,
            version: this.version,
          }
          this.$store.commit('USERDATAFUN', obj)
          let storage = window.localStorage;
          storage.setItem('userData', JSON.stringify(obj))
          
          
          this.formUser.email = data.data.email;

          console.log(data.data, "-----555---");
        },
        this,
        () => {}
      );
    },
    pageTypeFun(val) {
      // console.log(this.projectId)
      if(this.projectId||val=='projectSettings') {
        this.$emit("pageTypeFun", val);
      } else {
        this.$message({
          showClose: true,
          message: this.$t('App.message.text48'),
          type: "warning",
        });
      }
    },
    provinceItemClick(data) {
      // this.$store.commit("timezoneSelectFun", {
        // timezoneId: data.id,
        // timezoneName: data.name,
      // });
      console.log(data,'---4-4-44-')
      this.timezoneName = data.name
      this.timezoneId = data.id
      this.projectSelectShow = false;
    },
    timezoneSelectFun() {
      if(this.role == 2){
        return
      }
      if (this.projectSelectShow) {
        this.projectSelectShow = false;
      } else {
        this.projectSelectShow = true;
      }
    },

    timezoneNavList() {
      base.ajax_post(
        allUrl.user.user_timezoneList,
        {
          username: this.username,
          version: this.version,
          token: this.token,
        },
        {},
        (data) => {
          // this.$store.commit("timezoneNavListSelectFun", {
          for(let d of data.data){
            d.select = 0;
          }
          this.timezoneList = data.data;
          // this.timezoneId = data.data.id
          // });
          console.log(this.timezoneList,'-88--88')
          // console.log(this.timezoneId,'-88-')
          // if (!this.timezoneId) {
            // this.$store.commit("timezoneSelectFun", {
              // timezoneId: this.timezoneList[0].id,
              // timezoneName: this.timezoneList[0].name,
            // });
          // }
        },
        this
      );
    },
    profileSelectFun() {
      if (this.profileSelectShow) {
        this.profileSelectShow = false;
      } else {
        this.profileSelectShow = true;
      }
    },
  },
  watch: {
    // updateRemRatio:function(){
    // }
    // id: function () {
    //   this.userDetailsGet();
    // },
  },
};
</script>

<style type="text/css" lang="less">
.systemSetting_main {
  position: absolute;
  top: 7.37rem;
  left: 0;
  width: 100%;
  height: calc(100% - 7.37rem);
  min-height: 50rem;
  margin: 0 auto;
  overflow: hidden;
  // position: relative;
  display: flex;
  background: rgba(244, 251, 253, 0.85);
  padding: 4.39rem 7.37rem;
  // .bg{
  //   position: absolute;
  //   top: 0;left: 0;right: 0;bottom: 0;
  //   background: rgba(0,0,0,0.2);
  //   z-index: -1;
  // }
  .cont_left {
    width: 39.39rem;
    .p1 {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: rgba(58, 99, 111, 1);
      .i {
        color: #ff0101;
      }
    }
    .avatar_box {
      margin-top: 1.67rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .avatar {
        width: 12.02rem;
        height: 12.02rem;
        // background-image: url(../img/login/login_1.png);
        background-position: center;
        background-size: 100% 100%;
      }
    }
    .form_box {
      margin-top: 1.84rem;
      width: 39.39rem;
      height: 55rem;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 0.88rem;
      padding: 2.02rem 0 0 0;
      .input1 {
        margin: 0 0 1.05rem 3.7rem;
        width: 32.54rem;
        &.margin_b {
          margin-bottom: 4.5rem;
        }
        // width: 32.54rem;
        // height: 4.12rem;
        // border: 0.09rem solid #3A636F;
        // border-radius: 0.44rem;
        // margin: 2.02rem 0 0 3.77rem;
        .el-input__inner {
          padding-left: 4.56rem;
          width: 32.54rem;
          height: 4.12rem;
          line-height: 4.12rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
        .el-input__prefix {
          width: 1.8rem;
          height: 1.8rem;
          top: 0.96rem;
          left: 0.79rem;
          .icon {
            width: 100%;
            height: 100%
            
          }
          // .icon1 {
          //   background-image: url(../img/login/email.png);
          //   width: 12.02rem;
          //   height: 12.02rem;
          //   background-position: center;
          //   background-size: 100% 100%;
          // } 
          // .icon2 {
          //   background-image: url(../img/login/login_2.png);
          //   background-position: center;
          //   background-size: 100% 100%;
          // } 
          // .icon3 {
          //   background-image: url(../img/login/login_3.png);
          //   background-position: center;
          //   background-size: 100% 100%;
          // } 
          // .icon4 {
          //   background-image: url(../img/login/login_4.png);
          // }
        }
        .el-input__suffix {
          height: 4.12rem;
          line-height: 4.12rem;
          right: 1.49rem;
        }
        .span {
          margin-top: -0.2rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          position: relative;
          top: -0.2rem;
        }
        .el-input .el-select__caret {
          font-size: 1.8rem;
          color: rgba(58, 99, 111, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .addUser_btn {
        margin-left: 3.7rem;
        width: 5.53rem;
        height: 5.53rem;
        background-image: url(../img/login/login_1.png);
        background-position: center;
        background-size: 100% 100%;
        position: relative;
        cursor: pointer;
        margin-top: 1.76rem;
        .icon {
          position: absolute;
          top: 2.11rem;
          left: 3.07rem;
          width: 3.86rem;
          height: 3.86rem;
          background: #f4fbfd;
          border-radius: 50%;
          background-image: url(../img/icon/icon_add.png);
          background-position: center;
          background-size: 61% 61%;
          background-repeat: no-repeat;
        }
      }
      .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin-top: 1.75rem;
        margin: 1.75rem 0 1.05rem 3.7rem;
        width: 32.54rem;
        .btn1 {
          width: 9.91rem;
          height: 4.18rem;
          line-height: 4.18rem;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          border-radius: 0.26rem;
          text-align: center;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          cursor: pointer;
          user-select: none;
        }
        .btn2 {
          width: 9.91rem;
          height: 4.18rem;
          line-height: 4.18rem;
          background: #00c6ff;
          border: 0.09rem solid #00c6ff;
          border-radius: 0.26rem;
          text-align: center;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
          user-select: none;
        }
      }
    }
  }

  .cont_right {
    flex: 1;
    margin-left: 19.21rem;
    .p1 {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: rgba(58, 99, 111, 1);
      .i {
        color: #ff0101;
      }
    }
    .input1 {
      margin: 3.6rem 0 10.35rem;
      width: 32.54rem;
      &.margin_b {
        margin-bottom: 4.5rem;
      }
      // width: 32.54rem;
      // height: 4.12rem;
      // border: 0.09rem solid #3A636F;
      // border-radius: 0.44rem;
      // margin: 2.02rem 0 0 3.77rem;
      .el-input__inner {
        padding-left: 4.56rem;
        width: 32.54rem;
        height: 4.12rem;
        line-height: 4.12rem;
        border: 0.09rem solid #3a636f;
        border-radius: 0.44rem;
        background-color: rgba(0, 0, 0, 0);

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
      }
      .el-input__prefix {
        width: 1.8rem;
        height: 1.8rem;
        top: 0.96rem;
        left: 0.79rem;
        .icon {
          width: 100%;
        }
      }
      .el-input__suffix {
        height: 4.12rem;
        line-height: 4.12rem;
        right: 1.49rem;
      }
      .span {
        margin-top: -0.2rem;
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        position: relative;
        top: -0.2rem;
      }
      .el-input .el-select__caret {
        font-size: 1.8rem;
        color: rgba(58, 99, 111, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .skin_setting {
      display: flex;
      align-items: center;
      margin-top: 2.28rem;
      margin-bottom: 6.32rem;
      .li {
        width: 5.88rem;
        height: 5.88rem;
        border-radius: 50%;
        margin-right: 1.75rem;
        cursor: pointer;
        &.li1 {
          background: #2e2e2e;
        }
        &.li2 {
          background: #2f9fff;
        }
        &.li3 {
          background: #f39800;
        }
        &.add {
          background-image: url(../img/icon/btn_bg1.png);
          background-position: center;
          background-size: 100% 100%;
        }
      }
    }
    .contacts_settings {
      .box {
        display: flex;
        // height: 100%;
        width: 32.46rem;
        height: 6.49rem;
        background: rgba(58, 99, 111, 0.6);
        border-radius: 0.44rem;
        margin-bottom: 2.11rem;
        &.box1 {
          .box_l {
            .icon {
              background-image: url(../img/icon/icon1.png);
            }
          }
        }
        &.box2 {
          .box_l {
            .icon {
              width: 2.28rem;
              height: 4.91rem;
              background-image: url(../img/icon/icon2.png);
            }
          }
        }
        &.box3 {
          .box_l {
            flex-direction: column;
            .icon {
              width: 2.81rem;
              height: 3.33rem;
              margin: 0.2rem 0 0.2rem;
              background-image: url(../img/icon/icon3.png);
            }
          }
        }
        .box_l {
          display: flex;
          align-items: center;
          width: 10.09rem;
          flex: 1;
          .icon {
            width: 3.33rem;
            height: 2.89rem;
            background-image: url(../img/icon/icon1.png);
            background-position: center;
            background-size: 100% 100%;
            margin-left: 0.53rem;
            margin-right: 1.23rem;
          }
          .text {
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #effbff;
          }
        }
        .box_r {
          flex: 1;
          .el-input {
            width: 21.58rem;
            height: 3.16rem;
            border-radius: 0.44rem;
            margin-top: 0.05rem;
            &.input3 {
              .el-input__inner {
                background: rgba(244, 251, 253, 0.9);
              }
            }
            .el-input__inner {
              height: 3.16rem;
              line-height: 3.16rem;
              background: rgba(227, 249, 255, 0.9);
              border: 0.09rem solid rgba(58, 99, 111, 1);
              text-align: center;

              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #3a636f;
            }
          }
        }
      }
    }

    .btn_box {
      margin-top: 3.42rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      // margin-top: 1.75rem;
      // margin: 1.75rem 0 1.05rem 3.7rem;
      // width: 32.54rem;
      .btn1 {
        user-select: none;
        width: 9.91rem;
        height: 4.18rem;
        line-height: 4.18rem;
        background: #f4fbfd;
        border: 0.09rem solid #3a636f;
        border-radius: 0.26rem;
        text-align: center;

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        cursor: pointer;
      }
      .btn2 {
        user-select: none;
        margin-left: 11.75rem;
        width: 9.91rem;
        height: 4.18rem;
        line-height: 4.18rem;
        background: #00c6ff;
        border: 0.09rem solid #00c6ff;
        border-radius: 0.26rem;
        text-align: center;

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}

.ratio_1920_1080 {
  .systemSetting_main {
    position: absolute;
    top: 5.78rem;
    left: 0;
    width: 100%;
    height: calc(100% - 5.78rem);
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(244, 251, 253, 0.85);
    padding: 0;
    &.ja{
      .cont_right{
        .btn_box{
          .btn1{
            width: initial;
            padding: 0 0.5rem;
          }
        }
        .project_settings{
          width: 60rem;
        }
      }
      
    }  
    // .bg{
    //   position: absolute;
    //   top: 0;left: 0;right: 0;bottom: 0;
    //   background: rgba(0,0,0,0.2);
    //   z-index: -1;
    // }
    .cont_box {
      width: 100%;
      height: calc(100% - 5.78rem);
      display: flex;
    }
    .cont_left {
      width: 29.54rem;
      margin-left: 7.3rem;
      .p1 {
        font-size:1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: rgba(58, 99, 111, 1);
        .i {
          color: #ff0101;
        }
      }
      .avatar_box {
        margin-top: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .avatar {
          width: 6.71rem;
          height: 6.71rem;
          &.avatar0{
            background-image: url(../img/login/login_1.png);
            background-position: center;
            background-size: 100% 100%;
          }
        }
        
      }
      .select1 {
        position: relative;
        .select_lm {
          margin-left: 2.24rem;
          position: absolute;
          width: 20.53rem;
          height: 3.42rem;
          top: 40%;
          &.multiple {
            .li {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .selectDrop {
              margin-left: 1rem;
              width: 1.2rem;
              height: 1.2rem;
              border-radius: 50%;
              border: 0.15rem solid #00c6ff;
              display: flex;
              align-items: center;
              justify-content: center;
              visibility: hidden;

              &.select {
                visibility: initial;
              }

              .drop {
                width: 0.55rem;
                height: 0.55rem;
                background: #00c6ff;
                border-radius: 50%;
              }
            }
          }

          &.select {
            .val_box {
              .icon_x {
                transform: rotateZ(90deg);
              }
            }
          }

          .val_box {
            min-width: 20.53rem;
            height: 3.42rem;
            line-height: 3.42rem;
            padding-left: 1.38rem;
            padding-right: 5.46rem;
            cursor: pointer;
            display: flex;
            // align-items: center;
            justify-content: space-between;
            white-space:nowrap;
            background: #E4F9FF;
            border-radius: 0.66rem;
            border: 0.13px solid #3A636F;

            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            color: #3A636F;
            .i {
              top: 0.3rem;
              left: -1.5rem;
              position: absolute;
              margin-right: 0.5rem;
              color: #ff0101;
            }
            .img {
              width: 2.43rem;
              height: 2.24rem;
            }

            .val {
              font-family: Calibri;
              font-weight: normal;
              font-size: 1.8rem;
              color: #3a636f;
              margin-right: 0.5rem;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .icon_x {
              // transition: all 0.5s;
              position: absolute;
              top: 0.85rem;
              right: 1.1rem;
              width: 1.84rem;
              height: 1.84rem;
              transform: rotateZ(90deg);
              background-image: url("../img/icon/rightArrow.png");
              background-position: center;
              background-size: 100% 100%;
            }
          }

          .select_xl_lm_bg {
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
          }

          .select_xl_lm {
            position: absolute;
            left: 0.01rem;
            top: 4rem;
            border: 0.1rem solid #3a636f;
            border-radius: 0.5rem;
            z-index: 1;
            background: #f4fbfd;

            width: 28.95rem;
            height: 19.85rem;
            
            .ul {
              background: #f4fbfd;
              border-radius: 1rem;
              position: relative;
              z-index: 1;
              max-height: 20rem;
              margin: 0 0.5rem;

              // width: 28.95rem;
              // height: 19.85rem;
              .text{
                font-family: Calibri;
                font-weight: normal;
                font-size: 1.8rem;
                color: #3A636F;
                margin: 1.22rem 0 0 2.22rem ;
                
                .skin_setting {
                  display: flex;
                  align-items: center;
                  margin-top: 1.32rem;
                  margin-bottom: 2.09rem;
                  .li {
                    border-radius: 0.66rem;
                    margin-right: 1.38rem;
                    cursor: pointer;

                    width: 4.28rem;
                    height: 4.28rem;
                    &.li1 {
                      background: #00A0E9;
                    }
                    &.li2 {
                      background: #89C997;
                    }
                    &.li3 {
                      background: #EB6877;
                    }
                    &.li4 {
                      background: #f39800;
                    }
                  }
                }
                .form_item{
                  display: flex;
                  align-items: center;
                  // margin-bottom: 3.36rem;
                  .btn{
                    display:inline-block;
                    margin-right: 0.84rem;
                    width: 4.01rem;
                    height: 4.01rem;
                    &.btn0{
                      background-image: url('../img/icon/btn_bg1.png');
                      cursor: pointer;
                      background-position: center;
                      background-size: 100% 100%;
                      
                      // margin-right: 0.79rem;
                    }
                  }
                  .el-input__inner{
                    padding-left: 1.67rem;
                    width: 30rem;
                    height: 4rem;
                    line-height: 4rem;
                    border: 0.1rem solid #3A636F;
                    border-radius: 0.5rem;
                    background-color: rgba(0,0,0,0);
                    
                    font-size: 1.8rem;
                    font-family: Calibri;
                    font-weight: normal;
                    color: #3A636F;
                  }
                  .el-input__prefix{
                    width: 1.8rem;height: 1.8rem;
                    top: 0.96rem;left: 0.79rem;
                    .icon{
                      width: 100%;
                    }
                  }
                  .el-input__suffix{
                    height: 4.12rem;line-height: 4.12rem;
                    right: 1.49rem;
                  }
                  .span{
                    margin-top: -0.2rem;
                    font-size: 1.8rem;
                    font-family: Calibri;
                    font-weight: normal;
                    color: #3A636F;
                    position: relative;
                    top: -0.2rem;
                  }
                  .el-input .el-select__caret{
                    font-size: 1.8rem;
                    color: rgba(58, 99, 111, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
              }
              
            }
            .icon {
              position: absolute;
              // right: 1.2rem;
              left: 3.12rem;
              top: -0.5rem;
              width: 1rem;
              height: 1rem;
              background: #f4fbfd;
              border-top: 0.1rem solid #3a636f;
              border-left: 0.1rem solid #3a636f;
              // border-radius: 0.1rem;
              transform: rotateZ(45deg);
            }
            .li {
              padding-left: 1.25rem;
              padding-right: 1rem;
              height: 2.9rem;
              line-height: 2.9rem;
              font-family: Calibri;
              font-weight: normal;
              font-size: 1.8rem;
              color: #3a636f;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .edit {
                margin-left: 1rem;
                visibility: hidden;
                display: inline-block;
                width: 1.5rem;
                height: 1.5rem;
                background-image: url("../img/icon/edit.png");
                background-size: 100%;
                background-position: center;
              }
              &:hover {
                background: #e3f9ff;
                .edit {
                  visibility: initial;
                }
              }
              .text {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }

        &.margin_b {
          margin-bottom: 4.5rem;
        }
        // width: 32.54rem;
        // height: 4.12rem;
        // border: 0.09rem solid #3A636F;
        // border-radius: 0.44rem;
        // margin: 2.02rem 0 0 3.77rem;
        
        .span {
          margin-top: -0.2rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          position: relative;
          top: -0.2rem;
        }
      }
      
      .form_box {
        margin-top: 1.38rem;
        width: 29.54rem;
        height: 37.25rem;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 0.88rem;
        padding: 1.51rem 0 0 0;
        .input1 {
          margin: 0 0 1.05rem 2.7rem;
          width: 24.41rem;

          &.margin_b {
            margin-bottom: 0;
          }
          // width: 32.54rem;
          // height: 4.12rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          // margin: 2.02rem 0 0 3.77rem;
          .el-input__inner {
            padding-left: 3.42rem;
            width: 24.41rem;
            height: 3rem;
            line-height: 3rem;
            border: 0.09rem solid #3a636f;
            border-radius: 0.44rem;
            background-color: rgba(0, 0, 0, 0);

            // font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }
          .el-input__prefix {
            width: 1.64rem;
            height: 1.64rem;
            top: 0.75rem;
            left: 0.59rem;
            .icon {
              width: 100%;
            }
          }
          .el-input__suffix {
            height: 3rem;
            line-height: 3rem;
            right: 1.49rem;
          }
          .span {
            margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            position: relative;
            top: -0.2rem;
          }
          .el-input .el-select__caret {
            font-size: 1.8rem;
            color: rgba(58, 99, 111, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .addUser_btn {
          width: 4.14rem;
          height: 4.14rem;
          background-image: url(../img/login/login_1.png);
          background-position: center;
          background-size: 100% 100%;
          position: relative;
          cursor: pointer;
          margin-top: 1.06rem;
          .icon {
            position: absolute;
            top: 1.58rem;
            left: 2.3rem;
            width: 2.89rem;
            height: 2.89rem;
            background: #f4fbfd;
            border-radius: 50%;
            background-image: url(../img/icon/icon_add.png);
            background-position: center;
            background-size: 61% 61%;
            background-repeat: no-repeat;
          }
        }
        .btn_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          // margin-top: 1.75rem;
          // margin: 1.05rem 0 1.32rem 0;
          margin: 2.05rem 0 1.32rem 0rem;
          width: 100%;
          .btn1 {
            margin-left: 3.36rem;
            width: 7.43rem;
            height: 3.13rem;
            line-height: 3.13rem;
            background: #f4fbfd;
            border: 0.09rem solid #3a636f;
            border-radius: 0.26rem;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            cursor: pointer;
            user-select: none;
          }
          .btn2 {
            margin-right: 2.57rem;
            width: 7.43rem;
            height: 3.13rem;
            line-height: 3.13rem;
            background: #00c6ff;
            border: 0.09rem solid #00c6ff;
            border-radius: 0.26rem;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #ffffff;
            cursor: pointer;
            user-select: none;
          }
        }
      }
    }

    .cont_right {
      flex: 1;
      margin-left: 28.22rem;
      .p1 {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: rgba(58, 99, 111, 1);
        .i {
          color: #ff0101;
        }
      }
      .p2 {
        font-size: 1.5rem;
        font-family: Calibri;
        font-weight: normal;
        color: #ff0101;
      }
      .input1 {
        margin: 1rem 0 1rem;
        // width: 24.41rem;
        width: 27.56rem;
        .select_lm {
          margin-left: 0.5rem;
          position: relative;

          &.multiple {
            .li {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .selectDrop {
              margin-left: 1rem;
              width: 1.2rem;
              height: 1.2rem;
              border-radius: 50%;
              border: 0.15rem solid #00c6ff;
              display: flex;
              align-items: center;
              justify-content: center;
              visibility: hidden;

              &.select {
                visibility: initial;
              }

              .drop {
                width: 0.55rem;
                height: 0.55rem;
                background: #00c6ff;
                border-radius: 50%;
              }
            }
          }

          &.select {
            .val_box {
              .icon_x {
                transform: rotateZ(90deg);
              }
            }
          }

          .val_box {
            min-width: 27.57rem;
            height: 3.09rem;
            line-height: 3.09rem;
            border-radius: 0.2rem;
            border: 0.1rem solid #3a636f;
            position: relative;
            // padding-left: 0.5rem;
            // padding-right: 5.86rem;
            // cursor: pointer;
            display: flex;
            // align-items: center;
            // justify-content: space-between;
            .icon {
              width: 2.43rem;
              height: 2.24rem;
              margin-top:0.46rem;
              background-image: url(../img/icon/timeZone.png);
            }
            .i {
              top: 0.3rem;
              left: -1.5rem;
              position: absolute;
              margin-right: 0.5rem;
              color: #ff0101;
            }
            .img {
              width: 2.37rem;
              height: 2.24rem;
            }

            .val {
              position: absolute;
              font-family: Calibri;
              font-weight: normal;
              font-size: 1.8rem;
              color: #3a636f;
              margin-left: 2.88rem;
              // overflow: hidden;
              // white-space: nowrap;
              // text-overflow: ellipsis;
            }

            .icon_x {
              // transition: all 0.5s;
              position: absolute;
              top: 0.8rem;
              right: 1.08rem;
              width: 1.78rem;
              height: 1.78rem;
              transform: rotateZ(90deg);
              background-image: url("../img/icon/rightArrow.png");
              background-position: center;
              background-size: 100% 100%;
            }
          }
          .select_xl_lm_bg {
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
          }

          .select_xl_lm {
            position: absolute;
            left: 0;
            top: 3.7rem;
            width: 27.56rem;
            // height: 12rem;
            border: 0.1rem solid #3a636f;
            border-radius: 0.5rem;
            z-index: 1;
            background: #f4fbfd;

            .ul {
              background: #f4fbfd;
              border-radius: 1rem;
              position: relative;
              z-index: 1;
              max-height: 20rem;
              margin: 0 0.5rem;
            }

            .icon {
              position: absolute;
              right: 1.2rem;
              top: -0.5rem;
              width: 1rem;
              height: 1rem;
              background: #f4fbfd;
              border-top: 0.1rem solid #3a636f;
              border-left: 0.1rem solid #3a636f;
              // border-radius: 0.1rem;
              transform: rotateZ(45deg);
            }

            .li {
              padding-left: 1.25rem;
              padding-right: 1rem;
              height: 3rem;
              line-height: 3rem;
              font-family: Calibri;
              font-weight: normal;
              font-size: 1.8rem;
              color: #3a636f;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .edit {
                margin-left: 1rem;
                visibility: hidden;
                display: inline-block;
                width: 1.5rem;
                height: 1.5rem;
                background-image: url("../img/icon/edit.png");
                background-size: 100%;
                background-position: center;
              }
              &:hover {
                background: #e3f9ff;
                .edit {
                  visibility: initial;
                }
              }
              .text {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }

        &.margin_b {
          margin-bottom: 4.5rem;
        }
        // width: 32.54rem;
        // height: 4.12rem;
        // border: 0.09rem solid #3A636F;
        // border-radius: 0.44rem;
        // margin: 2.02rem 0 0 3.77rem;
        // .el-input__inner {
        //   padding-left: 4.34rem;
        //   width: 24.41rem;
        //   height: 3rem;
        //   line-height: 3rem;
        //   border: 0.09rem solid #3a636f;
        //   border-radius: 0.44rem;
        //   background-color: rgba(0, 0, 0, 0);

        //   font-size: 1.37rem;
        //   font-family: Calibri;
        //   font-weight: normal;
        //   color: #3a636f;
        // }
        // .el-input__prefix {
        //   width: 2.37rem;
        //   height: 2.24rem;
        //   top: 0.46rem;
        //   left: 1.05rem;
        //   .icon {
        //     width: 100%;
        //   }
        // }
        // .el-input__suffix {
        //   height: 4.12rem;
        //   line-height: 4.12rem;
        //   right: 1.49rem;
        // }
        .span {
          margin-top: -0.2rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          position: relative;
          top: -0.2rem;
        }
        // .el-input .el-select__caret {
        //   font-size: 2.2rem;
        //   color: rgba(58, 99, 111, 1);
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        // }
      }
      .skin_setting {
        display: flex;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 1rem;
        .li {
          width: 4.41rem;
          height: 4.41rem;
          border-radius: 50%;
          margin-right: 1.05rem;
          cursor: pointer;
          &.li1 {
            background: #2e2e2e;
          }
          &.li2 {
            background: #2f9fff;
          }
          &.li3 {
            background: #f39800;
          }
          &.add {
            background-image: url(../img/icon/btn_bg1.png);
            background-position: center;
            background-size: 100% 100%;
          }
        }
      }
      .contacts_settings {
        margin-top: 1rem;
        margin-left: 1.32rem;
        .box {
          display: flex;
          // height: 100%;
          width: 27.17rem;
          height: 4.87rem;
          background: rgba(58, 99, 111, 0.6);
          border-radius: 0.33rem;
          margin-bottom: 1rem;
          &.box1 {
            .box_l {
              justify-content: center;
              .icon {
                width: 2.5rem;
                height: 2.17rem;
                background-image: url(../img/icon/icon1.png);
              }
            }
          }
          &.box2 {
            .box_l {
              justify-content: center;
              .icon {
                width: 1.71rem;
                height: 3.68rem;
                background-image: url(../img/icon/icon2.png);
              }
            }
          }
          &.box3 {
            .box_l {
              flex-direction: column;
              .icon {
                width: 1.8rem;
                height: 2.5rem;
                margin: 0.2rem 0 0;
                background-image: url(../img/icon/icon3.png);
              }
            }
          }
          .box_l {
            display: flex;
            align-items: center;
            width: 8.2rem;
            flex: 1;
            // padding-top: 1.38rem;
            .icon {
              width: 2.5rem;
              height: 2.17rem;
              background-image: url(../img/icon/icon1.png);
              background-position: center;
              background-size: 100% 100%;
              margin-left: 0.39rem;
              margin-right: 0.92rem;
            }
            .text {
              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #effbff;
            }
          }
          .box_r {
            flex: 1;
            .el-input {
              width: 16.18rem;
              height: 2.4rem;
              border-radius: 0.33rem;
              margin-top: 0rem;
              &.input3 {
                .el-input__inner {
                  background: rgba(244, 251, 253, 0.9);
                }
              }
              .el-input__inner {
                height: 2.4rem;
                line-height: 2.4rem;
                background: rgba(227, 249, 255, 0.9);
                border: 0.09rem solid rgba(58, 99, 111, 1);
                text-align: center;

                font-size: 1.8rem;
                font-family: Calibri;
                font-weight: normal;
                color: #3a636f;
              }
            }
          }
        }
      }
      .project_settings {
        display: flex;
        width: 50rem;
        justify-content: space-around;
        margin-top: 1rem;
        .button{
          white-space:nowrap;
          // width: 13rem;
          padding: 0 0.5rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          border-radius: 0.26rem;
          text-align: center;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          cursor: pointer;
        }
      }
      .btn_box {
        margin-top: 1.42rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 23.36rem;
        // margin-top: 1.75rem;
        // margin: 1.75rem 0 1.05rem 3.7rem;
        // width: 32.54rem;
        .btn1 {
          user-select: none;
          width: 7.43rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          border-radius: 0.26rem;
          text-align: center;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          cursor: pointer;
        }
        .btn2 {
          user-select: none;
          margin-left: 11.75rem;
          width: 7.43rem;
          height: 3.13rem;
          line-height: 3.13rem;
          background: #00c6ff;
          border: 0.09rem solid #00c6ff;
          border-radius: 0.26rem;
          text-align: center;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
          &.noSelect{
            background:rgba(128,128,128,0.5);
            border-color:rgba(128,128,128,0.5);
            cursor: no-drop;
          }
        }
      }
    }
    .dialog_box{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
      }
      .form_box{
        position: relative;
        width: 40.53rem;
        height: 20.07rem;
        padding-top: 2.29rem;
        background: #F4FBFD;
        border-radius: 0.66rem;
        border: 0.09px solid #3A636F;
        opacity: 0.95;
        .span{
          font-family: Calibri;
          font-weight: 400;
          font-size: 1.8rem;
          color: #3A636F;
          text-align: center;
          margin-bottom: 2.72rem;
        }
        .input1 {
          margin: 0 auto 1.12rem;
          width: 27.5rem;
          display: block;
          &.margin_b{
            margin-bottom: 4.5rem;
          }
          // width: 32.54rem;
          // height: 4.12rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          // margin: 2.02rem 0 0 3.77rem;
          .el-input__inner{
            padding-left: 3.56rem;
            width: 27.5rem;
            height: 3.49rem;line-height: 3.49rem;
            border: 0.09rem solid #3A636F;
            border-radius: 0.44rem;
            background-color: rgba(0,0,0,0);
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
          }
          .el-input__prefix{
            width: 1.86rem;height: 1.86rem;
            top: 0.96rem;left: 0.79rem;
            .icon{
              width: 100%;
            }
          }
          .el-input__suffix{
            height: 4.12rem;line-height: 4.12rem;
            right: 1.49rem;
          }
          .span{
            margin-top: -0.2rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            position: relative;
            top: -0.2rem;
          }
          .el-input .el-select__caret{
            font-size: 1.8rem;
            color: rgba(58, 99, 111, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .btn_box{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // margin-top: 1.75rem;
          margin: 2.49rem auto 1.7rem;
          width: 26.69rem;
          .btn1{
            width: 8.38rem;
            height: 3.53rem;
            line-height: 3.53rem;
            background: #F4FBFD;
            border: 0.09rem solid #3A636F;
            border-radius: 0.26rem;
            text-align: center;
            
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3A636F;
            cursor: pointer;
            user-select: none;
          }
          .btn2{
            width: 8.38rem;
            height: 3.53rem;
            line-height: 3.53rem;
            background: #00C6FF;
            border: 0.09rem solid #00C6FF;
            border-radius: 0.26rem;
            text-align: center;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #FFFFFF;
            cursor: pointer;
            user-select: none;
          }
        }
      }
    }
    .project_completed{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
        opacity: 0.5;
      }
      .form_box{
        position: relative;
        width: 36.51rem;
        height: 18.09rem;
        padding-top: 2.83rem;
        background: #FFFFFF;
        border: 0px solid #3A636F;
        border-radius: 0.2rem;
        opacity: 0.9;
        .span{
          font-family: Calibri;
          color: #3A636F;
          text-align: center;
          width: 23.22rem;
          font-weight: 400;
          font-size: 1.8rem;
          color: #4C717C;
          margin: auto;
        }
        .btn_box{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 5.07rem;
          // margin: 4.47rem auto 0;
          // width: 26.69rem;
          
          .btn2{
            width: 6.25rem;
            height: 2.63rem;
            background: #00C6FF;
            border-radius: 0.2rem;

            line-height: 2.63rem;
            border: 0.09rem solid #00C6FF;
            text-align: center;
            // font-family: Calibri;
            // font-weight: normal;
            // color: #FFFFFF;
            cursor: pointer;
            user-select: none;

            font-family: Calibri;
            font-weight: 400;
            font-size: 1.8rem;
            color: #FFFFFF;
          }
        }
      }
    }
  }

}
input::-webkit-input-placeholder {
    font-size: 18px;
    font-weight: 400;
    color: #CCCCCC;
    position: relative;
    // top:-10px;
    top:-0.2rem;
}
input::-moz-input-placeholder {
    font-size: 18px;
    font-weight: 400;
    color: #CCCCCC;
    position: relative;
    top:-0.2rem;
}
input::-ms-input-placeholder {
    font-size: 18px;
    font-weight: 400;
    color: #CCCCCC;
    position: relative;
    top:-0.2rem;
}
// .systemSetting_main.themeType_1{
//   background: rgba(250,237,218,0.85);
//   .cont_left {
//     .p1{
//       color: #682411;
//     }
//     .avatar_box .avatar {
//           &.avatar0{
//             background-image: url(../img/orange/login_1.png);
//           }
//       }
//     .select1 .select_lm {
//       .val_box{
//         background: #faedda;
//         border: 0.15rem solid #682411;
//         color: #682411;
//         .icon_x {
//           width: 1rem;
//           height: 1.8rem;
//           background-image: url("../img/orange/rightArrow.png");
//         }
//       }
//       .select_xl_lm {
//         border: 0.1rem solid #682411;
//         background: #faedda;
//         .icon {
//           border-top: 0.1rem solid #682411;
//           border-left: 0.1rem solid #682411;
//         }
//         .ul {
//           background: #faedda;
//           .text {
//             color: #682411;
//             .form_item .btn{
//                 &.btn0{
//                   background-image: url('../img/orange/btn_bg1.png');
//                 }
//             }
//           }
//           .li {
//             // background: #fdbe6e;
//             &.select {
//               background: #fdbe6e;
//             }
//             &:hover {
//               background: #fdbe6e;
              
//             }
//           }
//         }
//       }
//     }
//     .form_box {
//       background: rgba(242, 205, 155, 0.5);
//       .input1 .el-input__inner {
//         background: #faedda;
//         border: 0.09rem solid #682411;
//         color: #682411;
//       }
//       // .input1 {
//       //   .el-input__prefix {
//       //     .icon {
//       //       // width: 100%;
//       //     }
//       //     .icon.icon1 {
//       //       background-image: url(../img/orange/login_1.png);
//       //     } 
//       //     .icon.icon2 {
//       //       background-image: url(../img/orange/login_1.png);
//       //     } 
//       //     .icon.icon3 {
//       //       background-image: url(../img/orange/login_3.png);
//       //     } 
//       //     .icon4 {
//       //       background-image: url(../img/orange/login_4.png);
//       //       // width: 5.53rem;
//       //       height: 1.8rem;
//       //     }
//       //   }
       
//       // }
//       .addUser_btn {
//         width: 5.1rem;
//         height: 4.4rem;
//         background-image: url(../img/orange/icon_add.png);
//         .icon {
//           display: none;
//         }
//       }
//       .btn_box .btn1{
//         background: #f2cd9b;
//         border: 0.09rem solid #682411;
//         color: #682411;
//       }
//       .btn_box .btn2{
//         background: #f44336;
//         border: 0.09rem solid #f44336;
//         color: #ffffff;
//       }
//     }
//   }
//   .cont_right {
//     .p1{
//       color: #682411;
//     }
//     .input1 .select_lm {
//       .val_box{
//         background: #faedda;
//         border: 0.15rem solid #682411;
//         .icon {
//           background-image: url(../img/orange/timeZone.png);
//         }
//         .val {
//           color: #682411;
//         }
//         .icon_x {
//           width: 1rem;
//           // height: 1.8rem;
//           background-image: url("../img/orange/rightArrow.png");
//         }
//       }
//       .select_xl_lm {
//         border: 0.1rem solid #682411;
//         background: #faedda;
//         .icon {
//           border-top: 0.1rem solid #682411;
//           border-left: 0.1rem solid #682411;
//         }
//         .ul {
//           background: #faedda;
//           .text {
//             color: #682411;
//           }
//         }
//         .li {
//           // background: #fdbe6e;
//           &.select {
//             background: #fdbe6e;
//           }
//           &:hover {
//             background: #fdbe6e;
            
//           }
//         }
//       }
//     }
//     .skin_setting 
//       .li {
//         &.add {
//           background-image: url(../img/orange/btn_bg1.png);
//           background-position: center;
//           background-size: 100% 100%;
//         }
//       }
    
//     .contacts_settings {
//       .box{
//         background: #e09259;
//         border: 0.1rem solid #682411;
//         .box_r .el-input .el-input__inner {
//           background: #faedda;
//           border: 0.09rem solid #682411;
//           color: #682411;
//         }
//         .box_r .el-input.input3 .el-input__inner {
//           background: #faedda;
//           // border: 0.09rem solid #682411;
//           color: #682411;
//         }
//         .box_l .text {
//           color: #682411;
//         }
        
//       }
//       .box.box3 .box_l .icon {
//         background-image: url(../img/orange/icon3.png);
//       }
//     }
//     .project_settings .button,
//     .btn_box .btn1{
//       background: #f2cd9b;
//       border: 0.09rem solid #682411;
//       color: #682411;
//     }
//     .btn_box .btn2{
//       background: #f44336;
//       border: 0.09rem solid #f44336;
//       color: #ffffff;
//     }
//   }
//   // .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
//   //     border-radius: 0.5rem;
//   //     // background: #DAE6E0;
//   //     background: #682411;
//   // }
//   // .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
//   //     background: #faedda;
//   // }
// }
</style>